//ts-nocheck
import React, { useState, useContext, useEffect, useRef } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { Collapse } from "react-bootstrap";
import "./MonthlyCommonDashboard.css";
import { LoaderContext, getContext } from "../../../../Helpers/Context/Context";
import { APICall } from "../../../../Helpers/Network/APICalls";
import {
  CommonDropdownData,
  GetNewMemberDetailsMonthWiseDashboard,
  GetFinancialYearDropdown,
  DownloadMemberRecoveryReport,
  DownloadMemberTableRecord,
} from "../../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../../Helpers/Enums/ApiStatus";
import { fetchAuthToken } from "../../../../Helpers/Network/OAuthHandler";
import notify, { ToastType } from "../../../../Helpers/ToastNotification";
import SelectForm from "../../../../Components/SelectForm/SelectForm";
import DynamicGrid from "../../../../Components/DynamicGrid/DynamicGrid";
import { MONTHSLIST, STARTYEAR } from "../../../../Helpers/Enums/Enum";
import MultiSelect from "../../../../Components/SelectForm/MultiSelect";
import { RoleEnum } from "../../../../Helpers/Enums/RoleEnum";
import { debug } from "console";


Modal.setAppElement("#root"); // Use the selector for your root element

const MonthlyCommonDashboard = (props) => {
  const { PageName, UploadExcel, ExportToExcelUrl, ExcelImport, openModal } =
    props;

  let navigate = useNavigate();
  const context = getContext();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [searchText, setSearchText] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [unitCodeOptions, setUnitCodeOptions] = useState([]);
  const [unitcode, setUnitCode] = useState([]);
  const [dashboardFilterOn, setDashboardFilterOn] = useState(false);
  const [financialYearOptions, setFinancialYearOptions] = useState([]);
  const [financialYearId, setFinancialYearId] = useState(null);
  const [financialYear, setFinancialYear] = useState(null);
  const [financialYearIdForDownload, setFinancialYearIdForDownload] =
    useState(null);
  const [months, setMonths] = useState([]);
  const [MonthIdForDownload, setMonthIdForDownload] =
    useState(null);
  const [dashboardData, setDashboardData] = useState([]);
  const [OpenUniCodeModal, setOpenUniCodeModal] = useState(false);
  const [fyear, SetFyear] = useState(null);
  const [FinancialYear, SetFinancialYear] = useState(null);
  const [month, SetMonth] = useState();
  const [monthId, setMonthId] = useState(null);
  const [formErrors, setFormErrors] = useState<any>({});
  const isAdmin = context?.CurrentRoleId === RoleEnum.Admin;
  const isInternalTeam = context?.CurrentRoleId === RoleEnum.InternalTeam;
  let MemberId = context.MemberId;
  let formErrorObj = {};
  const MONTHS_ENUM = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  useEffect(() => {
    showLoader();
    if (props?.refreshUnitcode) {
      props?.refreshUnitcode();
    }
    getDropDownDataApiCall();
    hideLoader();
  }, []);

  useEffect(() => {
    showLoader();
    getDashboardData("");
    hideLoader();
  }, [start, sortColumn, sortDirection, searchText, count]);

  const selectOnChange = (event: any, apiFieldName: any) => {
     
    if (apiFieldName === "FinancialYear") {
      setFinancialYear(event);
      setFinancialYearId(event.id);
    }
    if (apiFieldName === "Months") {
      setMonths(event);
      const monthId = MONTHS_ENUM[event.label];
      if (monthId) {
        setMonthId(monthId);
      }
    }
    // if (apiFieldName === "Months") {
    //   // setMonths(event);
    //   if ((event.label = MONTHS_ENUM.January)) {
    //     setMonths(event);
    //     setMonthId(1);
    //   } else if ((event.label = MONTHS_ENUM.February)) {
    //     setMonths(event);
    //     setMonthId(2);
    //   }
    // }

    if (apiFieldName === "UnitCode") {
      setUnitCode(event);
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        unitcode_isEmpty: "",
      }));
    }
  };

  const generateFinancialYearOptions = async () => {
    showLoader();
    const result = await APICall(GetFinancialYearDropdown, {});
    const yearOptions = result.Data?.map((item) => ({
      label: item.FinancialYear,
      value: item.Name,
      id: item.Id,
    }));
    if (result?.Data?.length > 0) {
      setFinancialYearOptions(yearOptions);
    }
    hideLoader();
  };

  const getDropDownDataApiCall = async () => {
     debugger
    showLoader();
    generateFinancialYearOptions();
    let requestParams;
    if (isAdmin) {
      requestParams = {
        dropdownName: "unitcodedd",
      };
    } else if (isInternalTeam) {
      requestParams = {
        dropdownName: "unitcodeInternalTeam",
        UserRoleId: context.Id,
      };
    }

    const res = await APICall(CommonDropdownData, requestParams);

    if (res.Status === ApiStatus.OK && res.Data.length > 0) {
      let options = await res.Data;
      await setUnitCodeOptions([...options]);
      hideLoader();
    } else {
      hideLoader();
      await setUnitCodeOptions([]);
    }
  };

  const CheckValidation = async () => {
    let objError: any = {};
    let error = false;
    // getGridStructure2();
    setFormErrors({});

    if (!unitcode || unitcode == null || unitcode.length <= 0) {
      error = true;
      objError["unitcode_isEmpty"] = "Unit code can not be empty";
    }
    setFormErrors(objError);
    return error;
  };

  const exportToExcelFunction = async () => {
    debugger
    let IsInValid = await CheckValidation(
      
    );
    if (IsInValid == false) {
      showLoader();
      const params = {
        FinancialYear: fyear,
        FinancialYearS: financialYearIdForDownload,
        MonthS: month,
        Month: MonthIdForDownload,
        DashboardType: PageName,
        UnitCode:
          unitcode && unitcode.length > 0
            ? unitcode.map(({ value }) => value).toString()
            : " ",
      };
      let token = await fetchAuthToken();
      axios
        .request({
          responseType: "blob",
          method: "POST",
          url: ExportToExcelUrl,
          //url:DownloadMemberRecoveryReport,
          data: params,
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Access-Control-Allow-Headers": "*",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          // console.log(response.data);
          // fileDownload(
          //   response.data,
          //   `${PageName}_Report_` +
          //     `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
          //     `.xlsx`
          // );
          

          // Extract the financial year and calculate the next year
          // const financialYear = financialYearIdForDownload;
          // const nextYear = parseInt(financialYear) + 1;
  
          // Create the file name
          const fileName = `${PageName}_${month}_${FinancialYear}.xlsx`;
  
          // Download the file
          fileDownload(response.data, fileName);

          hideLoader();
          setFormErrors({});
          setMonthId(null);
          setOpenUniCodeModal(false);
        })
        .catch((error) => {
          hideLoader();
          setFormErrors({});
          setOpenUniCodeModal(false);
         
          notify(ToastType.Error, "Failed to export data.");
        });
    }
  };

  const getDashboardData = async (btn: any) => {
     
    showLoader();
    let obj = {
      start: btn === "reset" ? 0 : start,
      resultsPerPage: btn === "reset" ? 12 : pageSize,
      searchText: btn === "reset" ? "" : searchText,
      sortColumn: btn === "reset" ? "" : sortColumn,
      sortDirection: btn === "reset" ? "" : sortDirection,
      FYId: btn === "reset" ? 0 : financialYearId ? financialYearId : 0,
      Month: btn === "reset" ? 0 : monthId ? monthId : null,
      UnitCodeId: "",
      DashboardType: PageName,
      // Month:
      //   months && months.length > 0
      //     ? months.map(({ value }) => value).toString()
      //     : "",
      // btn === "reset"
      //   ? ""
      //   : unitcode && unitcode.length > 0
      //   ? unitcode.map(({ value }) => value).toString()
      //   : "",
    };
    const resp = await APICall(GetNewMemberDetailsMonthWiseDashboard, obj);
    if (resp?.Data?.length > 0) {
      setDashboardData(resp?.Data);
    } else {
      setDashboardData([]);
    }
    setCount(resp?.Data?.[0]?.TotalCount || resp?.Data?.length || 0);
    hideLoader();
  };

  const resetFunction = async () => {
     
    setFinancialYear(null);
    setFinancialYearId(0);
    setMonths(null);
    setMonthId(null);
    setUnitCode([]);
    setSearchText("");
    setSortColumn("");
    setSortDirection("");
    setStart(0);
    setPageSize(12);
    setCount(0);
    setFormErrors({});
    setDashboardFilterOn(false);
    await getDashboardData("reset");
  };

  const onClickFunction = async (event, action) => {
     
    if (action === "Apply") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          // FinancialYear: financialYear.label ? financialYear.label : "",
          FinancialYear: financialYear && financialYear.label ? financialYear.label : "",
          Months:
            months && months.length > 0
              ? months.map(({ value }) => value).toString()
              : "",
          UnitCode:
            unitcode && unitcode.length > 0
              ? unitcode.map(({ value }) => value).toString()
              : "",
        };

     
        
        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          return f === "" || f === null || f === undefined;
        });

        // isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
        //   if (f === "" || f === null || f === undefined) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // });
      }

      if (isEmptyReqObj === true) {
        notify(1, "Please Select Financial Year.");
      } else {
        await getDashboardData("");
      }
    }
    // else if (action === "Reset") {
    //   await resetFunction();
    // }
  };

  const openUnitCodeModal = (fYear, Month, YearId,FinancialYears) => {
    debugger
    setFormErrors({});
    SetFyear(YearId);
    SetFinancialYear(FinancialYears);

  
    if (MONTHS_ENUM[Month]) {
      // setMonthId(monthId);
      let MonthIdForDownload = MONTHS_ENUM[Month];
      setMonthIdForDownload(MonthIdForDownload);
    }
    setFinancialYearIdForDownload(fYear);
    SetMonth(Month);
    setUnitCode(null);
    setOpenUniCodeModal(true);
  };


const SampleDownloadExcelOfMemberTableReco = async (Year,Month,YearId) => {
   
  // let IsInValid = await CheckValidation();
  // if (IsInValid == false) {
    showLoader();
    const params = {
      FinancialYear: YearId,
      FinancialYearS: financialYearIdForDownload,
      MonthS: MonthIdForDownload,
      Month: Month,
      DashboardType: PageName,
      // UnitCode:
      //   unitcode && unitcode.length > 0
      //     ? unitcode.map(({ value }) => value).toString()
      //     : " ",
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        // url: ExportToExcelUrl,
        url:DownloadMemberTableRecord,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(
          response.data,
          `${PageName}_Report_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
        hideLoader();
        setFormErrors({});
        setMonthId(null);
        setOpenUniCodeModal(false);
      })
      .catch((error) => {
        hideLoader();
        setFormErrors({});
        setOpenUniCodeModal(false);
       
        notify(ToastType.Error, "Failed to export data.");
      });
  // }
};

  const closeUniCodeModal = () => {
    setOpenUniCodeModal(false);
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "FinancialYear",
      label: "Financial Year",
      options: {
        display: true,
        filter: true,
        sort: true,
        setCellProps: () => ({
          style: { width: "400px" },
        }),
      },
    },
    {
      name: "Month",
      label: "Month",
      options: {
        display: true,
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: "400px" },
        }),
      },
    },
    {
      name: "ReportLink",
      label: "Report Link",
      options: {
        display: true,
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: "500px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          let YearId = tableMeta.rowData[0];
          let FinancialYears = tableMeta.rowData[1];
          let Year = tableMeta.rowData[1].split("-");
          let Month = tableMeta.rowData[2];
          if (Month == MONTHSLIST[0].value || Month == MONTHSLIST[1].value) {
            Year = parseInt(Year[0]) + 1;
          } else {
            Year = parseInt(Year[0]);
          }
          return (
            <>
              <a
                className="ReportLink"
                onClick={() => {
                   
                  openUnitCodeModal(Year, Month, YearId,FinancialYears);
                }}
                // onClick={() => {
                //   UploadExcel
                //     ? openModal(Year, Month)
                //     : openUnitCodeModal(Year, Month, YearId);
                // }}
                style={{ cursor: "pointer" }}
              >
                {value}
              </a>
            </>
          );
        },
      },
    },
    //only for Member Record report screen
    {
      name: "SampleDownload",
      label: "Sample Download",
      options: {
        display: PageName === "MemberTableReco",
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: "500px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          let YearId = tableMeta.rowData[0];
          let Year = tableMeta.rowData[1].split("-");
          let Month = tableMeta.rowData[2];
          const monthIdFromList = MONTHS_ENUM[Month];
          // if (monthId) {
          //   setMonthId(monthIdFromList);
          // }
          if (Month == MONTHSLIST[0].value || Month == MONTHSLIST[1].value) {
            Year = parseInt(Year[0]) + 1;
          } else {
            Year = parseInt(Year[0]);
          }
          return (
            <>
              <a
                className="ReportLink"
                onClick={() => {}}
                style={{ cursor: "pointer" }}
              >
                <i
                  className="fa fa-download"
                  // onClick={() => {
                  //   UploadExcel
                  //     ? openModal(Year, Month, YearId)
                  //     : openUnitCodeModal(Year, Month, YearId);
                  // }}
                  onClick={() => {
                    SampleDownloadExcelOfMemberTableReco(Year, monthIdFromList, YearId);
                  }}
                ></i>
              </a>
            </>
          );
        },
      },
    },
    {
      name: "SampleUpload",
      label: "Sample Upload",
      options: {
        display: PageName === "MemberTableReco",
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { width: "500px" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          let YearId = tableMeta.rowData[0];
          let FinancialYears = tableMeta.rowData[1];
          let Year = tableMeta.rowData[1].split("-");
          let Month = tableMeta.rowData[2];
          // const monthIdFromList = MONTHS_ENUM[Month];
          // if (monthId) {
          //   setMonthId(monthIdFromList);
          // }
          if (Month == MONTHSLIST[0].value || Month == MONTHSLIST[1].value) {
            Year = parseInt(Year[0]) + 1;
          } else {
            Year = parseInt(Year[0]);
          }
          return (
            <>
              <a
                className="ReportLink"
                // onClick={() => {
                //    ;
                //   // UploadExcel
                //   //   ? openModal(Year, Month)
                //   //   : openUnitCodeModal(Year, Month, YearId);
                // }}
                style={{ cursor: "pointer" }}
              >
                <i
                  className="fa fa-download"
                  onClick={() => {
                    UploadExcel
                      ? openModal(Year, Month, YearId)
                      : openUnitCodeModal(Year, Month, YearId,FinancialYears);
                  }}
                  // onClick={() => {
                  //   openUnitCodeModal(Year, Month, YearId);
                  // }}
                ></i>
              </a>
            </>
          );
        },
      },
    },
  ];

  // const handleRowClick = (rowData) => {
  //   const month = rowData[2]; // assuming month is at index 2
  //   setMonthId(month);
  // };

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end">
              <div className="col-lg-7 col-md-8 SearchBoxLocation pr-0">
                <div className="row d-flex ser_flx justify-content-end">
                  <div
                    className="float-right d-flex col-lg-5 col-md-6 justify-content-end pr-2 btns_mob"
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    {/* {UploadExcel && (
                      <Tooltip title="import to excel">
                        <button className="btn btn-submit" onClick={openModal}>
                          <i className="fa fa-upload"></i>
                        </button>
                      </Tooltip>
                    )} */}
                    <ul
                      className="float-right filter-icon  "
                      style={{ position: "relative" }}
                    >
                      <li
                        onClick={() =>
                          setDashboardFilterOn((current) => !current)
                        }
                        className="filter-btn"
                      >
                        <a className="filter-btn">
                          <i className="fa fa-filter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="clearfix"></div>
        <Collapse in={dashboardFilterOn}>
          <div className="filter-content">
            <div className="row">
              <div className="col-lg-3 col-md-4 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">Financial Year</label>
                  <SelectForm
                    options={financialYearOptions}
                    placeholder="Select Financial Year"
                    isDisabled={false}
                    value={financialYear}
                    onChange={(event: any) =>
                      selectOnChange(event, "FinancialYear")
                    }
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-4 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">Months</label>
                  <SelectForm
                    options={MONTHSLIST}
                    placeholder="Select Months"
                    isDisabled={false}
                    value={months}
                    onChange={(event: any) => selectOnChange(event, "Months")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-lg-12 col-md-12"
                style={{ marginBottom: "25px" }}
              >
                <div className="float-right">
                  <button
                    className="btn btn-cancel"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => resetFunction()}
                  >
                    <i className="fas fa-undo"></i> Reset
                  </button>
                  <button
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Apply")}
                  >
                    <i className="fas fa-check"></i> Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>

        <DynamicGrid
          // options={{
          //   ...Options,
          //    onRowClick: handleRowClick,
          // }}
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />

        <div className="ModalSize">
          <Modal
            ariaHideApp={false}
            isOpen={OpenUniCodeModal}
            onRequestClose={closeUniCodeModal}
            contentLabel="Unit Codes"
            style={{
              content: {
                width: "30%",
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "#ffffff",
                zIndex: "999",
              },
            }}
          >
            <div className="col-lg-12 p-0">
              <div className="row">
                <div
                  className="col-lg-12 col-md-12"
                  style={{ marginBottom: "15px" }}
                >
                  <div className="form-group">
                    <label className="col-form-label">Unit Code</label>
                    <MultiSelect
                      className="unitcodeSelect"
                      key="example_id"
                      options={unitCodeOptions}
                      onChange={(selectedOptions) =>
                        selectOnChange(selectedOptions, "UnitCode")
                      }
                      value={unitcode}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                      style={{ zIndex: "99999" }}
                    />
                    {/* <SelectForm
                      options={unitCodeOptions}
                      placeholder="Select Unit Code"
                      isDisabled={false}
                      value={unitcode}
                      onChange={(selectedOptions) =>
                        selectOnChange2(selectedOptions, "UnitCode")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    /> */}
                    <p style={{ color: "red" }}>
                      {formErrors["unitcode_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <button
                    className="btn btn-submit"
                    style={{ marginRight: "10px" }}
                    onClick={exportToExcelFunction}
                  >
                    <i className="fas fa-paper-plane"></i> Submit
                  </button>
                  <button
                    className="btn btn-cancel"
                    onClick={closeUniCodeModal}
                  >
                    <i className="far fa-times-circle"></i> Cancel
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
        {UploadExcel && <ExcelImport />}
      </div>
    </>
  );
};

export default MonthlyCommonDashboard;
